
import { uses } from "~/data/objectStorage";

export default {
  data() {
    return {
      items: uses,
    };
  },
};
